import { HAS_DISMISSED_INSURANCE_COVERAGE_BANNER, useUserSpecificLocalStorage } from '../../../hooks/use-local-storage';

/**
 * Determines if the insurance coverage banner should be shown
 * Banner is shown unless user has dismissed it
 * @returns {boolean} Whether to show the insurance coverage banner
 */
export const useShouldShowInsuranceCoverageBanner = () => {
  const [hasDismissedBanner] = useUserSpecificLocalStorage(HAS_DISMISSED_INSURANCE_COVERAGE_BANNER);

  return !hasDismissedBanner;
};
